import { useEffect, useRef } from 'react';
import { useTeacherReserveReferralInvite } from 'store/teacher-reserve/queries';
import { useHistory, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { TEACHER_QUERY_PARAMS } from 'platform-components';
import { getClasses } from 'common.components/user/selectors';

/** хук прикрепляет реферала по квери параметру referrerLinkId и удаляет его */
export const useTeacherReserveHandleReferral = () => {
    const [joinReferral] = useTeacherReserveReferralInvite();
    const { search } = useLocation();
    const history = useHistory();
    const classes = useSelector(getClasses);
    const isEffectWasActivated = useRef<boolean>(false);

    useEffect(() => {
        const queryParams = new URLSearchParams(search);
        const referrerLinkId = queryParams.get(TEACHER_QUERY_PARAMS.REFERRER_LINK_ID);
        if (referrerLinkId && !!classes.length && !isEffectWasActivated.current) {
            isEffectWasActivated.current = true;
            queryParams.delete(TEACHER_QUERY_PARAMS.REFERRER_LINK_ID);
            joinReferral(referrerLinkId);
            history.replace({
                search: queryParams.toString(),
            });
        }
    }, [classes, history, joinReferral, search]);
};
